export const anyExampleHasAttachments = (examples) => {
  return !!examples?.some(
    (example) => Object.keys(example.attachment_urls ?? {}).length > 0
  );
};
